export default __webpack_public_path__ + "static/ppq-modal-images-ec215d957cb7064614ec2ea6acfdbb5e.png";